var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiskClosure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9C6.00272 9 5.52581 8.80246 5.17417 8.45083C4.82254 8.09919 4.625 7.62228 4.625 7.125C4.625 6.425 5.00625 5.8125 5.5625 5.49375L11.6312 1.98125L8.175 7.96875C7.8625 8.58125 7.23125 9 6.5 9ZM6.5 0.875C7.63125 0.875 8.6875 1.1875 9.60625 1.7L8.29375 2.45625C7.75 2.24375 7.125 2.125 6.5 2.125C5.17392 2.125 3.90215 2.65178 2.96447 3.58947C2.02678 4.52715 1.5 5.79892 1.5 7.125C1.5 8.50625 2.05625 9.75625 2.9625 10.6562H2.96875C3.2125 10.9 3.2125 11.2937 2.96875 11.5375C2.725 11.7812 2.325 11.7812 2.08125 11.5437C0.95 10.4125 0.25 8.85 0.25 7.125C0.25 5.4674 0.90848 3.87769 2.08058 2.70558C3.25269 1.53348 4.8424 0.875 6.5 0.875ZM12.75 7.125C12.75 8.85 12.05 10.4125 10.9187 11.5437C10.675 11.7812 10.2812 11.7812 10.0375 11.5375C9.79375 11.2937 9.79375 10.9 10.0375 10.6562C10.9438 9.75 11.5 8.50625 11.5 7.125C11.5 6.5 11.3812 5.875 11.1625 5.3125L11.9187 4C12.4375 4.9375 12.75 5.9875 12.75 7.125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskClosure);
export default __webpack_public_path__ + "static/media/riskClosure.5af0f0be.svg";
export { ForwardRef as ReactComponent };